// cspell:disable

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import blogFetch from '../../axios/config';
import toast from 'react-hot-toast';
import { ModalApontamentoInspFinalProps } from './Types';
import ModalQRInspFinal from './ModalQRInspFinal';

const STORAGE_MATRICULA = 'listaMontagem_matriculas_SAP';
const ROTA_APONTAR = 'Quality/create';
const ROTA_VALIDAR_MATRICULA = 'IAcompanhamentoMontagem/validate-matricula';

const ModalApontamentoInspFinal: React.FC<ModalApontamentoInspFinalProps> = ({ show, onHide }) => {

    const [matricula, setMatricula] = useState<string>("");
    const [matriculaSAP, setMatriculaSAP] = useState<string>("");
    const [nomeUsuario, setNomeUsuario] = useState<string>("");
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const [isMatriculaModalOpen, setIsMatriculaModalOpen] = useState<boolean>(false);
    const [matriculaTemp, setMatriculaTemp] = useState<string>("");
    const [validandoMatricula, setValidandoMatricula] = useState<boolean>(false);

    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const validarMatriculaSAP = useCallback(async (valorMatricula: string): Promise<{ nome: string; matriculaSAP: string } | null> => {
        const valor = valorMatricula.trim();
        if (!/^\d{6}$/.test(valor)) return null;
        try {
            const { data } = await blogFetch.get(`${ROTA_VALIDAR_MATRICULA}/${encodeURIComponent(valor)}`);
            if (!data?.exists) return null;
            return { nome: data.nome ?? "", matriculaSAP: data.matricula_SAP ?? "" };
        } catch {
            return null;
        }
    }, []);

    const salvarMatriculaStorage = (valor: string, nome: string, matriculaSap: string) => {
        localStorage.setItem(
            STORAGE_MATRICULA,
            JSON.stringify({ principal: valor, nome, matriculaSAP: matriculaSap })
        );
    };

    const limparMatricula = () => {
        localStorage.removeItem(STORAGE_MATRICULA);
        setMatricula("");
        setNomeUsuario("");
        setMatriculaSAP("");
    };

    const abrirRegistroMatricula = () => {
        setMatriculaTemp(matricula);
        setIsMatriculaModalOpen(true);
    };

    const apontarPeca = async (ordemAprovada: string): Promise<boolean> => {
        const ordem = (ordemAprovada || "").trim();
        if (!ordem) return false;

        if (!/^\d{6}$/.test(matricula) || !matriculaSAP) {
            toast.error("Registre uma matrícula SAP válida para apontar.");
            abrirRegistroMatricula();
            return false;
        }

        setIsSubmitting(true);
        try {
            const { data } = await blogFetch.post(ROTA_APONTAR, {
                Centro_Trabalho: "18INSFIN",
                Nro_Matricula: user.user_SAPMatricula,
                Ordem_Fabricacao: ordem,
                Operacao: "4100",
                Tipo_Apontamento: "APROVADO",
                Chave_Modelo: "INSPFIN",
                Integration_Status: "NA FILA",
                _ts_Creat: new Date(Date.now() - 3 * 3600 * 1000),
                _Creat: user.user_UserName ?? user.user_Matricula,
            });

            if (data?.success) {
                toast.success(data.message ?? `Apontamento realizado para a ordem ${ordem}`);
                return true;
            }
            toast.error(data?.message ?? "Não foi possível apontar.");
            return false;
        } catch (error: any) {
            if (error?.response?.status === 409) {
                toast.error(error?.response?.data?.message ?? "Ordem já está apontada!");
                return false;
            }
            console.error("Erro ao realizar apontamento:", error);
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
            return false;
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleMatriculaChange = (valor: string) => setMatriculaTemp(valor.replace(/\D/g, "").slice(0, 6));

    const handleSalvarMatricula = async () => {
        const valor = matriculaTemp.trim();
        if (!/^\d{6}$/.test(valor)) {
            toast.error("A matrícula SAP deve ter 6 dígitos numéricos.");
            return;
        }
        setValidandoMatricula(true);
        const resultado = await validarMatriculaSAP(valor);
        setValidandoMatricula(false);
        if (resultado === null) {
            toast.error("Matrícula não encontrada no SAP");
            return;
        }
        salvarMatriculaStorage(valor, resultado.nome, resultado.matriculaSAP);
        setMatricula(valor);
        setNomeUsuario(resultado.nome);
        setMatriculaSAP(resultado.matriculaSAP);
        setMatriculaTemp("");
        setIsMatriculaModalOpen(false);
        toast.success(`Matrícula registrada: ${resultado.nome}`);
    };

    useEffect(() => {
        if (!show) return;
        const armazenado = localStorage.getItem(STORAGE_MATRICULA);
        if (!armazenado) return;

        let valor = "";
        let nomeSalvo = "";
        let matriculaSAPSalva = "";
        try {
            const obj = JSON.parse(armazenado);
            valor = obj.principal || obj.secundaria || "";
            nomeSalvo = obj.nome || "";
            matriculaSAPSalva = obj.matriculaSAP || "";
        } catch {
            valor = armazenado;
        }
        if (!valor) return;

        setMatricula(valor);
        setNomeUsuario(nomeSalvo);
        setMatriculaSAP(matriculaSAPSalva);

        (async () => {
            const resultado = await validarMatriculaSAP(valor);
            if (resultado === null) {
                limparMatricula();
                toast.error("Matrícula não encontrada no SAP");
                return;
            }
            setNomeUsuario(resultado.nome);
            setMatriculaSAP(resultado.matriculaSAP);
            salvarMatriculaStorage(valor, resultado.nome, resultado.matriculaSAP);
        })();
    }, [show, validarMatriculaSAP]);

    return (
        <>
            <ModalQRInspFinal
                show={show && !isMatriculaModalOpen}
                onHide={onHide}
                matricula={matricula}
                matriculaSap={matriculaSAP}
                operador={nomeUsuario}
                onTrocarOperador={abrirRegistroMatricula}
                processando={isSubmitting}
                onAprovado={apontarPeca}
            />

            <Modal show={isMatriculaModalOpen} onHide={() => setIsMatriculaModalOpen(false)} centered>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-4">Registrar Matrícula SAP</Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4">
                    <label className="form-label fw-semibold text-muted">MATRÍCULA SAP (6 dígitos)</label>
                    <input
                        type="text"
                        className="form-control form-control-lg text-primary fw-bold text-center"
                        placeholder="Ex: 123456"
                        value={matriculaTemp}
                        autoFocus
                        maxLength={6}
                        inputMode="numeric"
                        onChange={(e) => handleMatriculaChange(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") handleSalvarMatricula(); }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="lg" onClick={() => setIsMatriculaModalOpen(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={handleSalvarMatricula}
                        disabled={matriculaTemp.length !== 6 || validandoMatricula}
                    >
                        {validandoMatricula ? "Validando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalApontamentoInspFinal;
